import { Dialog, Loading, SelectCustomizable } from 'ui';
import PropTypes from 'prop-types';
import React from 'react';
import useDialogSelectSessions from './useDialogSelectSessions';

function DialogSelectSessions({ open, onClose, courseGuid, lessonGuid, sessions, onSuccessDialog, loading }) {
  const { t, selectedSessions, allSessions, onChangeSelectedSessions, loadingSessions } = useDialogSelectSessions({
    courseGuid,
    lessonGuid,
    sessions,
  });
  return (
    <Dialog
      isOpen={open}
      onClose={onClose}
      onCancel={onClose}
      title={t('common:Change the planned sessions')}
      size="m"
      onSuccess={() => onSuccessDialog(selectedSessions)}
      buttonTextSuccess={t('actions:Save')}
      className="dialog-select-sessions"
      isLoading={loading}
    >
      <div className="dialog-select-sessions__content">
        {loadingSessions ? (
          <Loading isFullScreen={false} />
        ) : (
          <SelectCustomizable
            options={allSessions}
            isOnFocusRefresh
            label={t('placeholder:Select sessions') + ':'}
            name="select-sessions"
            onChange={onChangeSelectedSessions}
            value={selectedSessions}
            disabled={!allSessions?.length}
            noOptionsMessage={t('placeholder:No sessions found')}
            isMulti={true}
          />
        )}
      </div>
    </Dialog>
  );
}

DialogSelectSessions.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  courseGuid: PropTypes.string,
  lessonGuid: PropTypes.string,
  sessions: PropTypes.array,
  onSuccessDialog: PropTypes.func,
  loading: PropTypes.bool,
};

export default DialogSelectSessions;
